import * as actions from 'actions/pageActionsV4';
import get from 'lodash/get';
const { PAGE_DATA_ACTIONS } = actions;
import { WIGGLE_VALIDATION_ACTION } from 'actions/TravelActions/wiggleValidationAction';
import { SECTION_ACTIONS } from 'actions/sectionActions';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
const defaultState = {
    wiggleData: {}
};
export var WIGGLE_ENTITIES;
(function (WIGGLE_ENTITIES) {
    WIGGLE_ENTITIES["ADDONS"] = "flightAddons";
})(WIGGLE_ENTITIES || (WIGGLE_ENTITIES = {}));
export default function (state = defaultState, action) {
    switch (action.type) {
        case WIGGLE_VALIDATION_ACTION.SET_WIGGLE_VALIDATION_DATA: {
            const { wiggleId } = action;
            return Object.assign(Object.assign({}, state), { wiggleId });
        }
        case PAGE_DATA_ACTIONS.SUCCESS: {
            let slots = get(action, 'data.slots') || [];
            let wiggleData = {};
            slots.forEach(slot => {
                const slotType = slot.slotType;
                const widetType = get(slot, ['widget', 'type']);
                if (slotType === SlotType.WIDGET) {
                    switch (widetType) {
                        // Add your Entities here which you want to wiggle - for example in BookingReviewPage
                        // we have addons as an entity;
                        case WidgetTypeV4.FLIGHT_ADDON: {
                            const addons = get(slot, [
                                'widget',
                                'data',
                                'addons'
                            ]);
                            let wiggleMetaData = {};
                            if (addons) {
                                addons.forEach(addon => {
                                    const addonId = get(addon, ['value', 'addonAttributes', 'id']);
                                    const selected = get(addon, ['value', 'addonAttributes', 'selected']);
                                    if (addonId !== undefined && selected !== undefined) {
                                        wiggleMetaData[addonId] = selected;
                                    }
                                });
                                wiggleData[WIGGLE_ENTITIES.ADDONS] = wiggleMetaData;
                            }
                            break;
                        }
                        default:
                    }
                }
            });
            return { wiggleData };
        }
        case PAGE_DATA_ACTIONS.REQUEST:
        case SECTION_ACTIONS.CHANGE_SECTION_TAB:
        case SECTION_ACTIONS.CONTINUE_TO_NEXT_SECTION_TAB: {
            return Object.assign(Object.assign({}, state), { wiggleId: undefined });
        }
        default:
            return state;
    }
}
